const endpoint = 'http://photos.thornqui.st/jsonp/';
//const endpoint = 'http://192.168.10.3:8099/jsonp/';
const photoUrl = 'http://photos.thornqui.st/photosrepo/';

export async function login(username, password) {
    const apiCall = await fetch(endpoint + 'login/' + username + '/' + password);
    const data = await apiCall.json();
    if (data.status === 404 || data.status === 500) { return false; }
    if (data.token) {
	localStorage.setItem('token', data.token);
	return true;
    }
    return false;
}

export function loggedIn() {
    let token = localStorage.getItem('token');
    if (token && 0 < token.length) {
	return true;
    }
    return false;
}

export async function logout() {
    localStorage.setItem('token', '');
}

export async function whenLoggedIn(f) {
    const token = localStorage.getItem('token')
    if (!token || 0 === token.length) {
	return
    }
    await fetch(endpoint + 'login/check', {
	method: 'POST',
	body: "token=" + token,
	headers: {
	    'Content-Type': 'application/x-www-form-urlencoded',
	    Authentication: token
	}
    })
	.then(r => r.json())
	.then(r => f(r));
}

export async function access() {
    const apiCall = await fetch(endpoint + 'access/');
    return apiCall.json();
}

function headers() {
    const token = localStorage.getItem('token');
    if (token) {
	return {
	    headers: { Authentication: token },
	    credentials: 'same-origin'
	};
    }
    return {};
}

export async function albums() {
    const apiCall = await fetch(endpoint + 'set/all', headers());
    return apiCall.json();
}

export async function album(id) {
    const apiCall = await fetch(endpoint + 'set/' + id + '/includeSubs', headers());
    return apiCall.json();
}

export async function addAlbum(name, accessId) {
    const apiCall = await fetch(endpoint + 'set/add/' + name + '/' + accessId, headers());
    return apiCall.json();
}

export function coverImage(album) {
    return mediaUrl(1, album.cover);
}

export function mediaUrl(size, id) {
    return photoUrl + 'size' + size + '/' + id + '.jpg';
}

export function videoUrl(media) {
    return photoUrl + 'video/' + media.videos[0].id + '.' + media.videos[0].extension;
}

export async function media(id) {
    const apiCall = await fetch(endpoint + 'media/' + id, headers());
    return apiCall.json();
}

export async function removeMedia(id, callback) {
    whenLoggedIn(async u => {
	if (u.levelId < 2) { return; }
	const token = localStorage.getItem('token');
	const apiCall = await fetch(endpoint + 'media/' + id, {
	    method: 'DELETE',
	    body: "token=" + token,
	    headers: { Authentication: token },
	    credentials: 'same-origin'
	}).then(callback());
	return apiCall.json();
    });
}

export async function setCover(set, media) {
    whenLoggedIn(async u => {
	if (u.levelId < 2) { return; }
	const token = localStorage.getItem('token');
	let apiCall = await fetch(endpoint + 'set/setCover/' + set + '/' + media, {
	    method: 'POST',
	    body: "token=" + token,
	    headers: { Authentication: token },
	    credentials: 'same-origin'
	});
	return apiCall.json();
    });
}		

export async function setCaption(media, caption, callback) {
    whenLoggedIn(async u => {
	if (u.levelId < 2) { return; }
	const token = localStorage.getItem('token');
	let data = new FormData();
	data.append('caption', caption);
	let req = new XMLHttpRequest();
	req.open("POST", endpoint + 'photo/caption/' + media, true);
	req.setRequestHeader("Authentication", token);
	req.send(data);
    });
}

export async function upload(file, setId, access, progress, callback) {
    if (file.type.match(/^video/)) {
	uploadVideo(file, setId, access, progress, callback);
    } else {
	uploadPhoto(file, setId, access, progress, callback);
    }
}

export async function uploadPhoto(file, setId, access, progress, callback) {
    uploadFile(file, endpoint + 'photo/' + setId + '/' + access, progress, callback);
}

export async function uploadVideo(file, setId, access, progress, callback) {
    uploadFile(file, endpoint + 'video/add/' + setId + '/' + access, progress, callback);
}

function uploadFile(file, path, progress, callback) {
    const token = localStorage.getItem('token');
    if (!token) return;
    let data = new FormData();
    data.append('file', file);
    data.append('title', file.name);
    if (progress) progress.setAttribute('max', '100');
    let req = new XMLHttpRequest();
    if (progress) {
	req.upload.addEventListener("progress", progressHandler(progress));
    }
    if (callback) req.onload = callback;
    req.open("POST", path, true);
    req.setRequestHeader("Authentication", token);
    req.send(data);
}

function progressHandler(progress) {
    return e => { if (e.lengthComputable) progress.setAttribute('value', parseInt(e.loaded/e.total*100)); }
}
